import React, { useEffect, useMemo, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer, { DEFAULT_SORTBY } from "../../components/Common/TableContainer";
import { get, post } from "./../../helpers/api_helper";
import { DASHBOARD, USER_LIST, REPORTS } from "../../helpers/url_helper";
import dashboardColumns from "./../../components/Columns/DashboardColumns";
import { useForm, Controller } from "react-hook-form";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { Link, useNavigate } from "react-router-dom";
import ticketReportColumns from "./../../components/Columns/ReportColumns";

const Dashboard = ({ t }) => {
  const [isAdmin, setIsAdmin] = useState(false);

  const currentInvoiceStatus = useRef();
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "ValSabji", link: "/" },
    { title: "Dashboard", link: "#" },
  ];


  const getFirstDayOfMonth = () => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  const { watch, } = useForm({
    defaultValues: {
      customer_ul_id: [],
      start_date: getFirstDayOfMonth(),
      end_date: new Date().toISOString().split("T")[0],
      report_type: "full_ledger",
      invoice_status: undefined,
    },
  });


  const invoiceStatus = watch("invoice_status");

  // console.log('invoiceStatus', )
  useEffect(() => {
    const status = typeof invoiceStatus === 'number' ? invoiceStatus : invoiceStatus?.value
    currentInvoiceStatus.current = status
  }, [invoiceStatus])

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const role = Number(authUser?.user?.role);
    setIsAdmin(role === 1);
  }, []);

  const [summaryData, setSummaryData] = useState({
    totalServices: 0,
    fullServices: 0,
    majorServices: 0,
    jobCards: 0,
  });

  const menuItems = [
    { key: "entryForm", path: "/entry-form" },
    { key: "boxReport", path: "/box-report" },
    { key: "depositEntryForm", path: "/deposit-entry-form" },
    { key: "creditMaster", path: "/credit-master" },
    { key: "udharReport", path: "/udhar-report" },
    { key: "javadMel", path: "/javad-mel" },
    { key: "creditDepositEntry", path: "/credit-deposit-entry" },
    { key: "averageReport", path: "/average-report" },
    { key: "hisabBook", path: "/hisab-book" },
    { key: "stockReport", path: "/stock-report" },
    { key: "itemMaster", path: "/item-master" },
    { key: "partyMaster", path: "/party-master" },
    { key: "creditUdhar", path: "/credit-udhar" },
    { key: "partyList", path: "/party-list" },
    { key: "party", path: "/party" },
    { key: "khatanoUtaro", path: "/account-statement" },
    { key: "backupRestore", path: "/backup-restore" },
    { key: "creditPankh", path: "/credit-paper" },
    { key: "bahar", path: "/exit" },
    { key: "udharChithi", path: "/udhar-chithi" },
    { key: "creditUdharani", path: "/credit-udharani" },
    { key: "wholeSaleBllList", path: "/whole-sale-bill-list" },
    { key: "reportForm", path: "/report-form" },
    { key: "accountReport", path: "/account-report" },
    { key: "accountEntry", path: "/account-entry" },
    { key: "traderSaleEntry", path: "/trader-sale-entry" }
  ];


  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Dashboard" breadcrumbItems={breadcrumbItems} />
          <div className="row">
            <div className="col-4">
              <div className="row justify-content-end align-items-end">
                {menuItems.map((item) => (
                  <div className="col-12 col-sm-6 col-md-4 mb-3" key={item.key}>
                    <Link
                      to={item.path}
                      className="p-2 rounded-lg shadow text-center d-block btn-info btn btn-lg w-100"
                    >
                      {t(item.key)}
                      {/* {item.key} */}
                    </Link>
                  </div>
                ))}
                <div className="col-12 col-sm-6 col-md-4 mb-3"></div>
                <div className="col-12 col-sm-6 col-md-4 mb-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Dashboard);
